export default __webpack_public_path__ + "static/1652-8ffa7240ec25ce4272519d7baa6bd1ef.jpg";